export default __webpack_public_path__ + "static/media/logo.544d4618.svg";